<template lang="pug">
  .empty-list(:class="{ vertical }") {{ label }}
    slot
</template>

<script>
export default {
  name: 'EmptyList',
  props: {
    label: String,
    vertical: Boolean,
  },
};
</script>

<style scoped>
  .empty-list {
    border: 1px solid #EBEFF2;
    box-sizing: border-box;
    border-radius: 6px;
    height: 50px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #99A3C5;
    padding: 30px;

    &.vertical {
      flex-direction: column;
      gap: 30px;
      height: auto;
      padding: 30px 0;
    }
  }
</style>
